export default __webpack_public_path__ + "static/media/Tiktok.f3c074ca.png";